const DEV_USER_KEY = 'po.devUser';
const LANG_KEY = 'po.lang';

const readKey = (key: string): string | null => {
  try { return localStorage.getItem(key); } catch { return null; }
};

const writeKey = (key: string, value: string | null): void => {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch { /* сховище недоступне (приватний режим) — ігноруємо */ }
};

/**
 * Dev-сесія транспорту (localStorage): e-mail Dev-користувача (заголовок X-Dev-User) і мова заголовка Accept-Language.
 * Мову сюди пише лише підписник store (state/store.ts) із session.lang — джерело істини для мови інтерфейсу одне.
 */
export const devSession = {
  get user(): string | null { return readKey(DEV_USER_KEY); },
  set user(email: string | null) { writeKey(DEV_USER_KEY, email || null); },
  get lang(): string { return readKey(LANG_KEY) ?? 'uk'; },
  set lang(value: string) { writeKey(LANG_KEY, value); },
};
